<template>
  <b-container class="bg-white" fluid>
    <b-row class="mb-4">
      <b-col>
        <b-link :to="{ name: 'AppReporting' }">Back to data loading</b-link>
        <b-button variant="outline-primary" class="mb-2" @click="generateReport">download report</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container>
          <div id="reportExport">
            <div style="font-family: Arial; font-size: 12px">
              <h1 style="color: #00338D;">Controls testing</h1>
              <h2 style="color: #00338D; margin-top: 50px;">Summary</h2>
              <table style="font-family: Arial; font-size: 12px;">
                <tr style="background-color: #00338D; color: white; font-weight: 700; padding-bottom: 10px; padding-top: 10px;">
                  <td>Theme</td>
                  <td>Controls tested</td>
                  <td>Without design findings</td>
                  <td>With design findings</td>
                </tr>
                <tr v-for="component in controls" :key="component.component">
                  <td>{{component.component}}</td>
                  <td>{{component.statsControls}}</td>
                  <td>{{component.statsControls - component.statsWithTodFindings}}</td>
                  <td>{{component.statsWithTodFindings}}</td>
                </tr>
                <tr style="font-weight: 700;">
                  <td>TOTAL</td>
                  <td>{{stats.controls}}</td>
                  <td>{{stats.controls - stats.withTodFindings}}</td>
                  <td>{{stats.withTodFindings}}</td>
                </tr>
              </table>
              <div v-for="component in controls" :key="component.component">
                <h2 style="color: #00338D; margin-top: 50px;">{{component.component}}</h2>
                <div v-for="control in component.controls" :key="control.Key">
                  <div>
                    <table style="font-family: Arial; font-size: 12px; background-color: #00338D; color: white;" width=100%>
                       <tr>
                         <td style="padding: 10px 5px 10px 5px;">
                           <h3 style="background-color: #00338D; color: white; font-size: 14px; font-weight: 700; padding: 0px 0px 0px 0px; margin: 0px 0px 0px 0xp;">{{control['Control Instance ID']}}</h3>
                          </td>
                        </tr>
                    </table>
                    <br />
                    <div><strong>Objective</strong><br />{{control['Objective']}}</div>
                    <br />
                    <div><strong>Description</strong><br /><markdown :content="control['Control Description']"></markdown></div>
                    <br />
                    <div><strong>Frequency:</strong> {{control['Frequency']}}</div>
                    <br />
                    <div><strong>Business area: </strong> {{control['Business Area']}}</div>
                    <br />
                    <div><strong>Location:</strong> {{control['Location']}}</div>
                    <br />
                    <div>
                      <strong>Design assessment</strong>
                      <div v-if="control.tod.length === 0">No issues noted</div>
                      <div v-if="control.tod.length > 0">
                        <div v-for="issue in control.tod" :key="issue.key">
                          <div><br /><strong>{{issue['Summary']}}</strong></div>
                          <div><markdown :content="issue['Description']"></markdown></div>
                        </div>
                      </div>
                    </div>
                    <br /><br />
                  </div>
                </div>
              </div>
              <h1 style="color: #00338D;">Appendix - Findings noted</h1>
              <h2 style="color: #00338D; margin-top: 50px;">Controls findings</h2>
              <table style="border: 1px solid #00338D; border-collapse: collapse; font-family: Arial; font-size: 12px;">
                <tr style="background-color: #00338D; color: white; font-weight: 700; padding-bottom: 10px; padding-top: 10px;">
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Theme</td>
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Control</td>
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Finding</td>
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Management response</td>
                </tr>
                <tr v-for="finding in findingsControls" :key="finding.key">
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{finding['Component/s']}}</td>
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{finding['Control Instance ID']}}</td>
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;"><strong>{{finding['Summary']}}</strong><div><markdown :content="finding['Description']"></markdown></div></td>
                  <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;"></td>
                </tr>
              </table>
              <div v-if="risks.length > 0">
                <br /><br />
                <h1 style="color: #00338D;">Appendix - Risk types</h1>
                <table style="border: 1px solid #00338D; border-collapse: collapse; font-family: Arial; font-size: 12px;">
                  <tr style="background-color: #00338D; color: white; font-weight: 700; padding-bottom: 10px; padding-top: 10px;">
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Risk id</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Level 4 risk type</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Definition</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">RTC function</td>
                  </tr>
                  <tr v-for="(risk, i) in risks" :key="'risk' + i">
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{risk.id}}</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{risk.type}}</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{risk.definition}}</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{risk.function}}</td>
                  </tr>
                </table>
              </div>
              <div v-if="policies.length > 0">
                <br /><br />
                <h1 style="color: #00338D;">Appendix - Policies reviewed</h1>
                <table style="border: 1px solid #00338D; border-collapse: collapse; font-family: Arial; font-size: 12px;">
                  <tr style="background-color: #00338D; color: white; font-weight: 700; padding-bottom: 10px; padding-top: 10px;">
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Name</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Owner</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Reviewed in ACR 2022</td>
                  </tr>
                  <tr v-for="(item, i) in policies" :key="'policy' + i">
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{item.name}}</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{item.owner}}</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{item.reviewed}}</td>
                  </tr>
                </table>
              </div>
              <div v-if="procedures.length > 0">
                <br /><br />
                <h1 style="color: #00338D;">Appendix - Procedures reviewed</h1>
                <table style="border: 1px solid #00338D; border-collapse: collapse; font-family: Arial; font-size: 12px;">
                  <tr style="background-color: #00338D; color: white; font-weight: 700; padding-bottom: 10px; padding-top: 10px;">
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Name</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Owner</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">Reviewed in ACR 2022</td>
                  </tr>
                  <tr v-for="(item, i) in procedures" :key="'policy' + i">
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{item.name}}</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{item.owner}}</td>
                    <td style="border: 1px solid #00338D; border-collapse: collapse; padding: 5px;">{{item.reviewed}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import _ from 'lodash'
import Markdown from '@/components/Markdown.vue'
import config from './config.js'

export default {
  name: "ReportingAppMain",
  components: {
    Markdown
  },
  data () {
    return {
      controls: [],
      findingsControls: [],
      policies: [],
      procedures: [],
      risks: [],
      stats: null
    }
  },
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: function () {
    this.$stat.log({ page: 'Reporting app main', action: 'open Reporting app main page' })
    const recordsRaw = {}
    config.files.forEach(x => {
      recordsRaw[x.id] = JSON.parse(localStorage.getItem('frmcloudReportingApp' + x.id))
    })
    if (recordsRaw.risks) {
      this.risks = recordsRaw.risks
    }
    if (recordsRaw.policies) {
      this.policies = recordsRaw.policies
    }
    if (recordsRaw.procedures) {
      this.procedures = recordsRaw.procedures
    }
    console.log(this.policies)
    const data = recordsRaw.main
    const componentsAll = []
    _.remove(data, x => {
      return x['Summary'].toUpperCase().match('NO DESIGN FINDING NOTED') || x['Summary'].toUpperCase().match('NO FINDINGS NOTED')
    })
    _.each(data, x => {
      if (x['Issue Type'] === 'Control') {
        componentsAll.push(x['Component/s'])
      }
      if (x['Finding Type'] === 'Design assessment (control)') {
        let summary = x['Summary']
        const space = summary.indexOf(' ')
        summary = summary.slice(space + 1)
        x['Summary'] = summary
      }
    })
    let findings = _.filter(data, x => {
      return x['Finding Type'] === 'Design assessment (control)'
    })
    findings = _.sortBy(findings, ['Component/s', 'Control Instance ID', 'Finding Type', 'Summary'])
    this.findingsControls = findings
    const components = _.uniq(componentsAll)
    const controls = []
    _.each(data, x => {
      if (x['Issue Type'] === 'Control') {
        x.tod = []
        x.toe = []
        controls.push(x)
      }
    })
    _.each(controls, control => {
      const tod = _.filter(data, x => {
        return x['Finding Type'] === 'Design assessment (control)' && x['Control Instance ID'] === control['Control Instance ID']
      })
      control.tod = tod
    })
    const controlsByComponent = []
    _.each(components, x => {
      const row = {
        component: x,
        controls: []
      }
      controlsByComponent.push(row)
    })
    _.each(controlsByComponent, x => {
      const rows = _.filter(controls, y => {
        return x.component === y['Component/s']
      })
      x.controls = rows
    })
    const controlsByComponentSorted = _.sortBy(controlsByComponent, ['component'])
    _.each(controlsByComponentSorted, x => {
      x.statsControls = x.controls.length
      x.statsWithTodFindings = _.reduce(x.controls, function (accumulator, value, key) {
        const count = value.tod.length > 0 ? 1 : 0
        return accumulator + count
      }, 0)
    })
    const stats = {
      controls: _.reduce(controlsByComponentSorted, function (accumulator, value, key) {
        return accumulator + value.statsControls
      }, 0),
      withTodFindings: _.reduce(controlsByComponentSorted, function (accumulator, value, key) {
        return accumulator + value.statsWithTodFindings
      }, 0)
    }
    this.controls = controlsByComponentSorted
    this.stats = stats
  },
  methods: {
    generateReport: function () {
      const start = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Report</title></head><body>"
      const end = "</body></html>"
      const html = start + document.getElementById('reportExport').innerHTML + end
      const url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html)
      const filename = 'report.doc'
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      link.click()
    }
  },
  watch: {
  }
}
</script>

<style>
</style>
